/**
 * Response formatting utilities
 */

import { ResponseFormat, ResponseFormatType } from "../core/types.js";

// Character limit for responses
const CHARACTER_LIMIT = 50000;

/**
 * Format response based on requested format
 */
export function formatResponse<T>(
  data: T,
  format: ResponseFormatType,
  markdownFormatter: (data: T) => string
): string {
  if (format === ResponseFormat.JSON) {
    return JSON.stringify(data, null, 2);
  }
  return markdownFormatter(data);
}

/**
 * Truncate response if too long
 */
export function truncateIfNeeded(text: string): string {
  if (text.length > CHARACTER_LIMIT) {
    return (
      text.substring(0, CHARACTER_LIMIT) +
      `\n\n... (truncated, ${text.length - CHARACTER_LIMIT} characters omitted)`
    );
  }
  return text;
}
